import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-460f8c9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "border-top border-outline-color" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "corporation-label" }
const _hoisted_4 = { class: "d-flex align-items-center flex-grow-0" }
const _hoisted_5 = { class: "text-size-14 text-weight-600 text-blue" }

import { formatCurrency } from "@/utils/number";
import { CorporationSalarySummary } from "@/types/balance/BalanceHistory";
import { PropType } from "vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SalaryDetailList',
  props: {
  corporationSalarySummaries: {
    type: Array as PropType<CorporationSalarySummary[]>,
    required: true
  }
},
  emits: ["clickDetail"],
  setup(__props, { emit: emits }) {

const props = __props;




function onClickDetail(corporationSalarySummary: CorporationSalarySummary) {
  emits("clickDetail", corporationSalarySummary);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.corporationSalarySummaries, (corporationSalarySummary) => {
      return (_openBlock(), _createElementBlock("div", {
        key: 'corporation-summary' + corporationSalarySummary.corporationId,
        class: "bg-white border-bottom border-outline-color"
      }, [
        _createElementVNode("div", {
          class: "detail-item",
          onClick: ($event: any) => (onClickDetail(corporationSalarySummary))
        }, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(corporationSalarySummary.name), 1),
          _createTextVNode(),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(formatCurrency)(corporationSalarySummary.totalIncome)), 1),
            _createTextVNode(),
            _createVNode(FeatherIcon, {
              icon: "chevron-right",
              size: "1x",
              class: "text-gray-05 ml-1"
            })
          ])
        ], 8, _hoisted_2)
      ]))
    }), 128))
  ]))
}
}

})